module.exports = __webpack_public_path__ + "static/img/A-apple.c760ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-apple.png
// module id = VkKt
// module chunks = 4